// import App from "../App";
import React from "react";
import { useRouteMatch, useParams } from "react-router";
import { useEffect } from "react";
import { inject, observer } from "mobx-react";
import Table from "./views/table/Table";
import ExtjsReport from "./views/ExtjsReport";
import Toolbar from "./ToolBar/Toolbar";
import { DIMENSIONS } from "utils/Dimensions";
import SaveResetButtonsSnackBar from "./SaveResetButtonsSnackBar";
import { ContainerStoreContext, ViewStoreContext } from "./ContainerStore";
import { useConfirm } from "material-ui-confirm";
import { RenderDashBoard , DashBoardToolbar } from "../../app/TabBar/PackDashBoard";
import { useState } from "react";

const Spinner = require("react-spinkit");

function Container({ appStore, themeColor, listId }) {
  const [update, setUpdate] = useState(false)
  const showDashBoard = listId === "dashboard" ? true : false;
  const store = appStore.getCurrentListContainerStore(listId);
  const confirm = useConfirm();
  const currentViewStore = store.getCurrentViewStore();

  if (store.isLoading && !store.view) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 300, // todo fix this
        }}
      >
        <Spinner name="line-scale" color="rgb(35, 127, 244)" />
      </div>
    );
  }

  if (!store.view && !showDashBoard) {
    return <div></div>;
  }

  return (
    <ContainerStoreContext.Provider value={store}>
      <ViewStoreContext.Provider value={currentViewStore}>
        {showDashBoard ? (
           <>
           <DashBoardToolbar
             setUpdate={() => {
               setUpdate(!update);
             }}
           />
           <RenderDashBoard
             update={update}
           />
         </>
        ) : (
          <>
            <Toolbar
              view={store.listConfig ? store.view : {}}
              rowHeight={
            store.view?.options?.options?.row_height ??
            DIMENSIONS.cell_height_short
          }
              // setRowHeight={store.getCurrentViewStore()?.setRowHeight}
              params={currentViewStore?.params}
              themeColor={themeColor}
              store={currentViewStore}
              redrawGrid={currentViewStore?.addGrid}
            />
            {store.isLoading && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: 300,
                }}
              >
                <Spinner name="line-scale" color="rgb(35, 127, 244)" />
              </div>
            )}
            {!store.isLoading &&
              !!store.listConfig &&
              !!store.view.type &&
              (store.view.type !== "table" ? (
                <ExtjsReport
                  listConfig={store.listConfig}
                  view={store.view}
                  listId={listId}
                  viewId={store.view.id}
                />
              ) : (
                <>
                  {currentViewStore ? (
                    <Table
                      listConfig={store.listConfig}
                      view={store.view}
                      listId={listId}
                      viewId={store.view.id}
                      store={currentViewStore}
                      confirm={confirm}
                    />
                  ) : null}
                </>
              ))}
            <SaveResetButtonsSnackBar
              open={
            store.saveResetButtonsPosition === "snackbar" &&
            store.isSaveResetButtonsOpen
          }
              isSubSheetView = {
                store.view?.type == "table" &&
                store.view?.list_id &&
                store.view?.options?.main_list_id &&
                store.view?.list_id != store.view?.options?.main_list_id &&
                !store.unSavedViewOfEditReport
              }
            />
          </>
        )}
      </ViewStoreContext.Provider>
    </ContainerStoreContext.Provider>
  );
}

export default inject(({ store: appStore }) => ({
  appStore,
}))(observer(Container));
